import { render, staticRenderFns } from "./SetTestTrafficAgentSimCards.vue?vue&type=template&id=75936179&"
import script from "./SetTestTrafficAgentSimCards.vue?vue&type=script&lang=js&"
export * from "./SetTestTrafficAgentSimCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports